import icon from 'vue-svgicon';

icon.register({
    'regular/pin-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M19.75 8.25c0 4.221-2.933 6.649-5.131 9-1.316 1.408-2.369 6-2.369 6s-1.05-4.589-2.363-5.993c-2.2-2.35-5.137-4.782-5.137-9.007a7.5 7.5 0 0 1 15 0z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="1" cx="12.25" cy="8.25" r="3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
